import styled from 'styled-components';

import Button from '~_components/_core/Button';

export const SearchButton = styled(Button)`
  margin-top: 22px;
  margin-left: 15px;
`;
